// src/components/album/voice/MediaVoiceIndicator.jsx
import React from 'react';
import { Mic, Volume2, Waveform } from 'lucide-react';

export const MediaVoiceIndicator = ({ 
  voiceNotes = [], 
  indicatorStyle = 'waveform',
  onClick 
}) => {
  if (!voiceNotes || voiceNotes.length === 0) return null;

  const pinnedNote = voiceNotes.find(note => note.isPinned);
  const noteCount = voiceNotes.length;

  // Waveform Animation Style
  if (indicatorStyle === 'waveform') {
    return (
      <div 
        onClick={onClick}
        className="absolute bottom-2 left-2 flex items-center gap-1 bg-purple-600 bg-opacity-90 backdrop-blur-sm rounded-full px-3 py-1.5 shadow-lg cursor-pointer hover:bg-opacity-100 transition-all group"
      >
        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className="w-0.5 bg-white rounded-full animate-pulse"
            style={{
              height: `${8 + Math.random() * 8}px`,
              animationDelay: `${i * 0.15}s`,
              animationDuration: '1s'
            }}
          />
        ))}
        <span className="text-white text-xs font-medium ml-1">{noteCount}</span>
      </div>
    );
  }

  // Badge Style
  if (indicatorStyle === 'badge') {
    return (
      <div
        onClick={onClick}
        className="absolute top-2 right-2 w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center shadow-lg cursor-pointer hover:scale-110 transition-transform group"
      >
        <Mic className="w-5 h-5 text-white" />
        {noteCount > 1 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-pink-500 rounded-full flex items-center justify-center text-white text-xs font-bold border-2 border-white">
            {noteCount}
          </span>
        )}
      </div>
    );
  }

  // Corner Flag Style
  if (indicatorStyle === 'corner-flag') {
    return (
      <div 
        onClick={onClick}
        className="absolute top-0 right-0 w-16 h-16 overflow-hidden cursor-pointer group"
      >
        <div className="absolute transform rotate-45 bg-purple-600 text-white text-xs font-bold py-1 right-[-20px] top-[10px] w-[80px] text-center shadow-lg group-hover:bg-purple-700 transition-colors">
          <Mic className="w-3 h-3 inline" />
        </div>
      </div>
    );
  }

  // Overlay Hint Style
  if (indicatorStyle === 'overlay-hint') {
    return (
      <div 
        onClick={onClick}
        className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3 cursor-pointer"
      >
        <div className="flex items-center gap-2 text-white text-sm">
          <Volume2 className="w-4 h-4" />
          <span>Tap to hear {noteCount > 1 ? `${noteCount} stories` : 'the story'}</span>
        </div>
      </div>
    );
  }

  // Minimal Style (default)
  return (
    <div
      onClick={onClick}
      className="absolute top-2 right-2 w-8 h-8 bg-purple-600 bg-opacity-90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-md cursor-pointer hover:bg-opacity-100 transition-all"
    >
      <Mic className="w-4 h-4 text-white" />
      {noteCount > 1 && (
        <span className="absolute -bottom-1 -right-1 w-4 h-4 bg-pink-500 rounded-full flex items-center justify-center text-white text-[10px] font-bold border border-white">
          {noteCount}
        </span>
      )}
    </div>
  );
};